function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PDF_icon_nowyplik",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_42",
  "data-name": "Rectangle 42",
  width: 11.508,
  height: 1.384,
  transform: "translate(5.525 5.946)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_43",
  "data-name": "Rectangle 43",
  width: 11.508,
  height: 1.384,
  transform: "translate(5.525 10.844)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_44",
  "data-name": "Rectangle 44",
  width: 11.508,
  height: 1.384,
  transform: "translate(5.525 20.639)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_45",
  "data-name": "Rectangle 45",
  width: 11.508,
  height: 1.384,
  transform: "translate(5.525 15.742)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M70.876,33.333H54.543a3.113,3.113,0,0,0-3.113,3.113V59.867a3.113,3.113,0,0,0,3.113,3.113H70.876a3.113,3.113,0,0,0,3.113-3.113V36.446A3.113,3.113,0,0,0,70.876,33.333ZM71.6,55.054v4.365a1.112,1.112,0,0,1-1.112,1.112H54.927a1.112,1.112,0,0,1-1.112-1.112V36.894a1.112,1.112,0,0,1,1.112-1.112H70.492A1.112,1.112,0,0,1,71.6,36.894Z",
  transform: "translate(-51.43 -33.333)",
  fill: "#ccc"
}));

var SvgDraftFileIcon = function SvgDraftFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.559,
    height: 29.647,
    viewBox: "0 0 22.559 29.647",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDraftFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/draft_file_icon.5bffe7f6.svg";
export { ForwardRef as ReactComponent };